/* global globalThis */
import React, { useCallback, useEffect } from 'react';

import { message } from 'antd';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Ajax } from '../components/Ajax';
import { T } from '../components/Translations';
import { PopupTypes } from '../components/Popup';

import { hideLoader, showLoader } from '../Shared/Loader';

import store from './../store';
import { openPopup } from '../store/actions';

import { Project } from './Project';

/**
 *the list of custom events occuring for specific actions
 */
export const EVENT_NAME = {
    SHOW_LOADER: "SHOW_LOADER",
    HIDE_LOADER: "HIDE_LOADER",
    SERVICE_CALL_LIST_UPDATE: "SERVICE_CALL_LIST_UPDATE",
    PLANNING_BLOCK_LIST_UPDATE: "PLANNING_BLOCK_LIST_UPDATE",
    APPOINMENT_SCHEDULE_REPAINT: "APPOINMENT_SCHEDULE_REPAINT",
    APPOINMENT_SCHEDULE_UPDATE: "APPOINMENT_SCHEDULE_UPDATE",
    SERVICE_CALL_UPDATED: "SERVICE_CALL_UPDATED",
    SERVICE_CALL_RELOAD: "SERVICE_CALL_RELOAD",
    FEE_LIST_UPDATE: "FEE_LIST_UPDATE",
    FEE_DATA_RELOAD: "FEE_DATA_RELOAD",
    SPARE_PART_LIST_UPDATE: "SPARE_PART_LIST_UPDATE",
    SPARE_PART_DATA_RELOAD: "SPARE_PART_DATA_RELOAD",
    DPC_LIST_UPDATE: "DPC_LIST_UPDATE",
    ATTACHMENTS_LIST_UPDATE: "ATTACHMENTS_LIST_UPDATE",
    ATTACHMENTS_CONTRACT_LIST_UPDATE: "ATTACHMENTS_CONTRACT_LIST_UPDATE",
    CALL_ASSIGNED: "CALL_ASSIGNED",
    HISTORY_LIST_UPDATE: "HISTORY_LIST_UPDATE",
    SERVICE_CONTRACT_LIST_UPDATE: "SERVICE_CONTRACT_LIST_UPDATE",
    SERVICE_CONTRACT_RELOAD: "SERVICE_CONTRACT_RELOAD"
}

/**
 *the method for custom event creation
 * @param {string} eventName
 * @param {Function} callback
 */
export function useCustomEvent(eventName, callback) {
    useEffect(
        () => {
            if (eventName && callback) {
                let events = eventName.split(" ");
                for (const event of events) {
                    document.addEventListener(event, handler);
                }
                return () => {
                    for (const event of events) {
                        document.removeEventListener(event, handler);
                    }
                }

                function handler(e) {
                    callback(e);
                }
            }
        },
        [eventName, callback]
    );
}

/**
 *the method to trigger custom event
 * @param {string} eventName
 * @param {any} data
 */
export function dispatchCustomEvent(eventName, data) {
    let events = eventName?.split(" ");
    if (events) {
        for (const event of events) {
            const customEvent = new CustomEvent(event, { bubbles: true, detail: data });
            document.dispatchEvent(customEvent);
        }
    }
}

/**
 *custom hook to ensure(for front end) the login state on specific pages
 * @param {any} props
 */
export function useLoginCheck(props) {
    const historyHook = useHistory();
    useEffect(() => {
        if (!props.skipLogin && !store.getState().isLoggedIn) {
            let history = props.history || historyHook;
            history.push("/login?redirectUrl=" + globalThis.location.pathname);
        };
    }, [props.history, props.skipLogin, historyHook]);
}

const deleteLoaderName = 'DELETE_LOADER';

/**
 *custom hook creating specific delete method for each list and form given props
 * @param {any} props { nameField, deleteUrl, backPage, deleteKeys, listUpdateEvent, endDelete, deleteMessage, textYes, textNo }
 */
export function useDelete(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const { nameField, deleteUrl, backPage, deleteKeys, listUpdateEvent, startDelete, endDelete, deleteMessage, popupTitle, textYes, textNo, post } = props;
    const onDelete = useCallback((record, callback) => {
        dispatch(openPopup({
            windowKey: 'wndConfirmDelete',
            type: PopupTypes.Confirm,
            title: <T args={[nameField ? record[nameField] : record.nom]}>{popupTitle || 'message.delete_title'}</T>,//`Delete ‘${record.nom}‘`,
            text: <T>{deleteMessage || "message.delete_confirm"}</T>, //'This action cannot be undone. Are you sure you want to continue?',
            buttonYesText: <T>{textYes || "text.delete"}</T>,//Defines.Messages.confirmDelete,
            buttonNoText: <T>{textNo || "text.cancel"}</T>,//Defines.Messages.cancelDelete,
            yesCallback: function () {
                showLoader(deleteLoaderName);
                if(startDelete) { startDelete(); }
                if (deleteKeys) {
                    let data = [];
                    deleteKeys.map((key) => {
                        return data[key] = record[key];
                    })
                    Ajax.post({
                        url: deleteUrl,
                        data: {
                            data
                        },
                        success: function (response) {
                            if (response) {
                                dispatchCustomEvent(listUpdateEvent, { action: "delete" });
                                callback?.(response) || (backPage && history.push(Project.getPageUrl(backPage)));
                            }

                            if(endDelete) { endDelete(); }
                            hideLoader(deleteLoaderName);
                        },
                        error: function (response) {
                            if (response.message) {
                                message.error(response.message);
                            }
                            hideLoader(deleteLoaderName);
                        }
                    })
                } else {
                    Ajax[post ? "post" : "get"]({
                        url: deleteUrl,
                        data: record,
                        success: function (response) {
                            if (response) {
                                dispatchCustomEvent(listUpdateEvent, { action: "delete" });
                                (callback?.(response)) || (backPage && history.push(Project.getPageUrl(backPage)));
                            }
                            if(endDelete) { endDelete(); }
                            hideLoader(deleteLoaderName);
                        },
                        error: function (response) {
                            if (response.message) {
                                message.error(response.message);
                            }
                            hideLoader(deleteLoaderName);
                        }
                    })
                }

            }
        }));
    }, [deleteUrl, nameField, listUpdateEvent, backPage, endDelete, startDelete, deleteKeys, deleteMessage, textNo, textYes, popupTitle,post, history, dispatch]);

    return onDelete;
}

export function cloneDataItem(dataItem) {
    return Object.assign({}, dataItem);
}

export function deepCopy(inObject) {
    let outObject, value, key

    if (typeof inObject !== "object" || inObject === null) {
        return inObject;
    }

    outObject = Array.isArray(inObject) ? [] : {}
    for (key in inObject) {
        value = inObject[key]
        outObject[key] = deepCopy(value)
    }

    return outObject
}